import styled from "styled-components";

export const HeadinghWrapper = styled.div`
  h2 {
    font-size: 42px;
    font-weight: 600;
    line-height: 110%;
  }
`;
